// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal-dialog {
  max-width: 600px !important;
}

#striped-light .card {
  margin: 0;
}

form .col-form-label {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.table thead th {
  background: transparent;
  color: #586562;
  border-top: none;
}
.table tbody tr:hover {
  background: #e4f1fa;
}

.progressbar-value {
  top: 50%;
  left: 50%;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/commission/modals/calculatecommissionhistory.screen.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEE;EACE,SAAA;AACJ;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AACF;;AAGI;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;AAAN;AAKM;EACE,mBAAA;AAHR;;AAQA;EACE,QAAA;EACA,SAAA;EACA,iBAAA;AALF","sourcesContent":["div.modal-dialog {\n  max-width: 600px !important;\n}\n#striped-light {\n  .card {\n    margin: 0;\n  }\n}\nform .col-form-label {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.table {\n  thead {\n    th {\n      background: transparent;\n      color: #586562;\n      border-top: none;\n    }\n  }\n  tbody {\n    tr {\n      &:hover {\n        background: #e4f1fa;\n      }\n    }\n  }\n}\n.progressbar-value {\n  top: 50%;\n  left: 50%;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
